import { render, staticRenderFns } from "./DoctorLabReport.vue?vue&type=template&id=a28e85ec"
import script from "./DoctorLabReport.vue?vue&type=script&lang=js"
export * from "./DoctorLabReport.vue?vue&type=script&lang=js"
import style0 from "./DoctorLabReport.vue?vue&type=style&index=0&id=a28e85ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports